import { NavLink } from "react-router";

const aba = ({ isActive }: { isActive: boolean }) =>
  `flex min-h-11 flex-1 items-center justify-center rounded-md px-3 text-center font-semibold ${isActive ? "bg-chapa shadow" : "text-aco-escuro hover:bg-chapa/60"}`;

/** As duas formas da Entrada avulsa: bipando (coletora) ou digitando o SKU (várias linhas, computador). */
export function AbasEntrada() {
  return (
    <div className="flex flex-col gap-2">
      <nav className="flex gap-1 rounded-lg bg-concreto p-1" aria-label="Como dar a entrada">
        <NavLink to="/estoque/entrada" end className={aba}>Bipando</NavLink>
        <NavLink to="/estoque/adicionar" end className={aba}>Digitando o SKU</NavLink>
      </nav>
      <p className="text-sm text-aco-escuro">
        Para estoque que entra sem nota: acerto, produto achado, carga inicial. Mercadoria do fornecedor entra pelo Recebimento e
        devolução de cliente por Receber devolução; as duas depois vão para as posições pela Armazenagem.
      </p>
    </div>
  );
}
